module.exports = __webpack_public_path__ + "static/3-8feb0c00826a7a047285ffa5029e75f0.jpg";